import { subscribe } from '@ps/web-core-api';
import type { APIConfig, Message } from '@ps/web-core-api';
import type { StompHeaders } from '@stomp/stompjs';
import type { Observable } from 'rxjs';

import type { EffectParams, Store } from '../types';

import { WMTConnection } from './WMTConnection';

export const storeSubscribe = <TMessage extends Message<unknown>>(
  destination: string,
  {
    select,
    rootState,
    dispatch
  }: {
    select: EffectParams['select'];
    rootState: EffectParams['rootState'];
    dispatch: EffectParams['dispatch'];
  },
  headers: StompHeaders = {},
  overrides?: Partial<APIConfig>
): Observable<TMessage> => {
  const store = { getState: () => rootState, select, dispatch } as Store;
  const wmtConnection = WMTConnection(store, overrides);
  return subscribe(destination, headers, wmtConnection);
};
